import DropdownCommon from "Components/Common/Component/DropdownCommon";
import ReactApexChart from "react-apexcharts";
import CountUp from "react-countup";
import { Card, CardBody, CardHeader } from "reactstrap";
import { H4, H5 } from "AbstractElements";
import { DailyDropdown, OrderThisMonthTitle } from "../../../Constant";
import { OrderThisMonthChart } from "../../../Data/Ecommerce/Chart";
const OrderThisMonth = () => {
  return (
    <Card className="card">
      <CardHeader className="card-header card-no-border">
        <div className="header-top">
          <H5 attrH5={{ className: "m-0" }}>{OrderThisMonthTitle}</H5>
          <div className="card-header-right-icon">
            <DropdownCommon
              dropdownMain={{ className: "icon-dropdown", direction: "start" }}
              options={DailyDropdown}
              iconName="icon-more-alt"
              btn={{ tag: "span" }}
            />
          </div>
        </div>
      </CardHeader>
      <CardBody className="card-body pt-0">
        <div className="light-card balance-card d-inline-block">
          <H4 attrH4={{ className: "m-0 text-white" }}>
            <CountUp className="me-1" duration={0} separator="," end={1054} /> trường hợp
          </H4>
        </div>
        <div className="order-wrapper">
          <ReactApexChart
            type="bar"
            height={220}
            options={OrderThisMonthChart.options}
            series={OrderThisMonthChart.series}
          />
        </div>
      </CardBody>
    </Card>
  );
};

export default OrderThisMonth;
